/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Such_Icy_Carp_ChopInputs */

const fr_such_icy_carp_chop = /** @type {(inputs: Such_Icy_Carp_ChopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type Abo`)
};

/**

* @param {Such_Icy_Carp_ChopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const such_icy_carp_chop = /** @type {((inputs?: Such_Icy_Carp_ChopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Such_Icy_Carp_ChopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_such_icy_carp_chop(inputs)
});